import { ITheme } from "../../utils/theme";

export const DatePickerStyle = (theme: ITheme) => ({
  background: 'white',
  width: '100%',
  '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline, .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.info.light,
    borderWidth: '3px'
  },
  '& .MuiIconButton-root': {
    color: theme.palette.info.light,
  },
  '& .MuiFormHelperText-root': {
    m: 0
  },
  '& .Mui-error': {
    background: theme.palette.grey[500],
  }
});

export const GridItemStyle = () => ({
  marginBottom: { xs: 2, md: 4 }
});

export const asteriskStyle = {
  color: (theme: ITheme) => theme.palette.red.A700,
  marginLeft: 1
}

export const descriptionStyle = {
  marginTop: 3,
  marginBottom: 4,
  textAlign: { xs: 'center' }
};

export const buttonContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
};

export const selectStyle = (theme: ITheme) => ({
  width: '100%',
  '& .MuiInputBase-root.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.red[700],
  }
});